import { DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI } from '../../entities';
import { TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { AzureDevopsIcon } from './icon';
import { AzureDevopsSearchResultIcon } from './search-result-icon';

export const azureDevopsConfig: ThirdPartyConfig = {
	displayName: 'Azure DevOps',
	id: 'azure-devops',
	resourceType: 'azure-devops-connector',
	icon: get3PLogo(AzureDevopsIcon, 'AzureDevOps', 'medium'),
	searchResultIcon: get3PLogo(AzureDevopsSearchResultIcon, 'AzureDevOps', 'large'),
	integrationAri: 'ari:cloud:platform::integration/azure-devops',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Repository,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: true,
	isEnabled: () => true,
};
